(ns iris.styles.message-bar
  (:require
  ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))


(def $message-bar
  (css
   :fixed
   :left-0
   :bottom-0
   :w-full
   {:z-index "100000"
    :background-color "#d3d3d3"
    :height "50px"
    :line-height "50px"
    :border-top "2px solid #999"
    :padding "0 0 0 10px"
    :font-family "monospace"
    :font-size "14px"}))


(def $message-bar-span
  (css
   :block
   :overflow-auto
   :whitespace-nowrap
   {:margin-right "55px"
    :line-height "50px"
    :margin-left "10px"
    :height "50px"}))

(def $message-bar-logs-btn
  (css
   :absolute
   :bottom-0
   :right-0
   :border-0
   :rounded-md
   :p-4
   :m-2
   {:background "navy"}
   [:hover {:filter "brightness(120%)"}]))

(def $fb-auth-state-bar
  (css
   :absolute
   :left-0
   :w-full
   :text-white
   :text-center
   :bg-red-600
   {:bottom "50px"}))




;; (defn message-bar []
;;   {:position "fixed"
;;   ;;  :z-index 1000
;;    :z-index 100000 ;; must be above moderator logs panel
;;    :left 0
;;    :bottom 0
;;    :background-color "#d3d3d3"
;;    :width "100%"
;;    :height "50px"
;;    :line-height "50px"
;;    :border-top "2px solid #999"
;;    :padding "0 0 0 10px"
;;    :font-family "monospace"
;;    :font-size "14px"})

;; (defn message-bar-span []
;;   {:display "block"
;;    :overflow "auto"
;;    :margin-right "55px"
;;    :line-height "50px"
;;    :margin-left "10px"
;;    :height "50px"
;;    :white-space "nowrap"})

;; (defn message-bar-logs-btn []
;;   {:position "absolute"
;;    :height "40px"
;;    :width "40px"
;;    :top 0
;;    :right 0
;;    :border 0
;;    :background "navy"
;;    :padding 0
;;    :margin "5px"
;;    :border-radius "4px"})

;; (defn fb-auth-state-bar []
;;   {:position "absolute"
;;    :left "0"
;;    :width "100%"
;;    :bottom "50px"
;;    :text-align "center"
;;    :background-color "red"
;;    :color "white"})


;; #message-bar{
;;   position: fixed;
;;   z-index: 1000;
;;   left: 0;
;;   bottom: 0;
;;   /* background-color: #f9f9f9; */
;;   background-color: #d3d3d3;
;;   width:100%;
;;   height: 50px;
;;   line-height: 50px;
;;   border-top: 2px solid #999;
;;   padding: 0 10px;
;;   font-family: monospace;
;;   font-size: 14px;
;; }